{
  "el": {
    "window": {
      "app": "Εφαρμογή",
      "customersAnnouncements": "Ενημερώσεις έργου",
      "customersDashboard": "Αρχική",
      "customersDecisionDocuments": "Απόφαση",
      "customersDecisionProposals": "Προτάσεις απόφασης",
      "customersDecisionTickets": "Απόφαση",
      "customersDecisionTicketsShow": "Απόφαση",
      "customersDecisions": "Αποφάσεις",
      "customersDocuments": "Έγγραφα",
      "customersDocumentsAll": "Επισκόπηση εγγράφων",
      "customersDocumentsFolder": "Κατηγορία εγγράφων",
      "customersDocumentsFolders": "Κατηγορίες εγγράφων",
      "customersInspirationLists": "Εμπνεύσεις",
      "customersInspirationListsShow": "Εμπνεύσεις",
      "customersInstallmentTerms": "Δόσεις",
      "customersIssues": "Παρατηρήσεις",
      "customersIssuesList": "Παρατηρήσεις",
      "customersProjectInformation": "Πληροφορίες έργου",
      "customersQuestionLists": "FAQ",
      "customersQuestionListsShow": "FAQ",
      "customersRoot": "Αρχική",
      "customersRootSettingsProfile": "Ρυθμίσεις",
      "customersSettingsProfile": "Ρυθμίσεις",
      "customersTickets": "Συνομιλίες",
      "customersTicketsNew": "Νέα συνομιλία",
      "customersTicketsShow": "Συνομιλία",
      "employeesClientContacts": "Επαφές",
      "employeesClientContactsNew": "Νέα επαφή",
      "employeesClientContactsNewCustomer": "Νέος πελάτης",
      "employeesClientContactsNewPartner": "Νέος συνεργάτης",
      "employeesClientContactsType": "Επαφές",
      "employeesClientDashboard": "Αρχική",
      "employeesClientProjects": "Έργα",
      "employeesClientProjectsNew": "Νέο έργο",
      "employeesClientTickets": "Συνομιλίες",
      "employeesClientTicketsNew": "Νέα συνομιλία",
      "employeesClientTicketsShow": "Συνομιλία",
      "employeesMarketplace": "Marketplace",
      "employeesProjectActivity": "Ιστορικό",
      "employeesProjectAnnouncements": "Ανακοινώσεις",
      "employeesProjectDecisionActivity": "Ιστορικό",
      "employeesProjectDecisionDocuments": "Απόφαση",
      "employeesProjectDecisionProposalTemplate": "Πρότυπα προτάσεων",
      "employeesProjectDecisionProposals": "Προτάσεις",
      "employeesProjectDecisionReminders": "Υπενθυμίσεις",
      "employeesProjectDecisionTickets": "Συνομιλίες",
      "employeesProjectDecisionTicketsShow": "Συνομιλία",
      "employeesProjectDecisionTypeNew": "Νέα απόφαση",
      "employeesProjectDecisionTypes": "Αποφάσεις",
      "employeesProjectDecisions": "Αποφάσεις",
      "employeesProjectDecisionsEdit": "Αποφάσεις",
      "employeesProjectDecisionsNew": "Νέα απόφαση",
      "employeesProjectDocuments": "Έγγραφα",
      "employeesProjectInformationPageActivity": "Ιστορικό",
      "employeesProjectInformationPageAftercare": "Παρατηρήσεις",
      "employeesProjectInformationPageDecisions": "Αποφάσεις",
      "employeesProjectInformationPageDocuments": "Έγγραφα",
      "employeesProjectInformationPageInformation": "Πληροφορίες",
      "employeesProjectInformationPageInstallments": "Δόσεις",
      "employeesProjectInformationPageLevels": "Επίπεδα",
      "employeesProjectInformationPageMilestones": "Workflows",
      "employeesProjectInformationPageSpaces": "Βοηθητικοί χώροι",
      "employeesProjectInformationPageSurveys": "Ερωτηματολόγια",
      "employeesProjectInformationPageTaskAssignments": "Εργασίες",
      "employeesProjectInformationPageTasks": "Εργασίες",
      "employeesProjectInformationPageTickets": "Συνομιλίες",
      "employeesProjectInstallmentGroup": "Οικονομικά",
      "employeesProjectInstallmentGroupNew": "Νέο πρόγραμμα δόσεων",
      "employeesProjectInstallmentGroups": "Οικονομικά",
      "employeesProjectInstallmentGroupsList": "Οικονομικά",
      "employeesProjectInstallmentGroupsMatrix": "Δόσεις",
      "employeesProjectInstallmentNew": "Νέες δόσεις",
      "employeesProjectIssueListTypeIssues": "Λίστα παρατηρήσεων - Όλες οι παρατηρήσεις",
      "employeesProjectIssueListTypeNew": "Νέα λίστα παρατηρήσεων",
      "employeesProjectIssueListTypeUnits": "Λίστα παρατηρήσεων - Επισκόπηση ακινήτων",
      "employeesProjectIssueListTypes": "Λίστες παρατηρήσεων",
      "employeesProjectIssueListUnitDocuments": "Παρατηρήσεις ακινήτου - Έγγραφα",
      "employeesProjectIssueListUnitIssues": "Παρατηρήσεις ακινήτου",
      "employeesProjectIssueListUnitTickets": "Παρατηρήσεις ακινήτου - Συνομιλίες",
      "employeesProjectIssueListUnitTicketsShow": "Συνομιλίες",
      "employeesProjectIssueListsNew": "Νέες παρατηρήσεις",
      "employeesProjectMilestones": "Workflows",
      "employeesProjectQuestionLists": "FAQ",
      "employeesProjectQuestionListsShow": "FAQ",
      "employeesProjectSalesUnits": "Πωλήσεις",
      "employeesProjectSurveySummary": "Ερωτηματολόγιο",
      "employeesProjectSurveyTypes": "Ερωτηματολόγια",
      "employeesProjectSurveys": "Ερωτηματολόγιο",
      "employeesProjectTasks": "Εργασίες",
      "employeesProjectTickets": "Συνομιλίες",
      "employeesProjectTicketsEmailConversations": "Email",
      "employeesProjectTicketsEmailConversationsShow": "Email",
      "employeesProjectTicketsNew": "Νέα συνομιλία",
      "employeesProjectTicketsShow": "Συνομιλίες",
      "employeesProjectTodoLists": "Εργασίες",
      "employeesSettingsClientAftercare": "Παρατηρήσεις",
      "employeesSettingsClientInformation": "Διαχείριση",
      "employeesSettingsClientIntegrations": "Ενσωματώσεις",
      "employeesSettingsProfile": "Προφίλ",
      "level": "Επίπεδο",
      "mployeesProjectInstallmentGroups": "Οικονομικά",
      "partnersClientProjects": "Έργα",
      "partnersProjectDecisionDocuments": "Έγγραφα",
      "partnersProjectDecisionProposals": "Προτάσεις",
      "partnersProjectDecisionTickets": "Συνομιλίες",
      "partnersProjectDecisionTicketsShow": "Συνομιλία",
      "partnersProjectDecisionTypesItems": "Αποφάσεις",
      "partnersProjectDecisions": "Αποφάσεις",
      "partnersProjectDocuments": "Έγγραφα",
      "partnersProjectDocumentsUnit": "Έγγραφα",
      "partnersProjectIssueListTypeIssues": "Λίστα παρατηρήσεων - Όλες οι παρατηρήσεις",
      "partnersProjectIssueListTypeUnits": "Λίστα παρατηρήσεων - Επισκόπηση ακινήτων",
      "partnersProjectIssueListTypes": "Παρατηρήσεις",
      "partnersProjectIssueListUnitDocuments": "Παρατηρήσεις ακινήτου - Έγγραφα",
      "partnersProjectIssueListUnitIssues": "Παρατηρήσεις ακινήτου",
      "partnersProjectIssueListUnitTickets": "Παρατηρήσεις ακινήτου - Συνομιλίες",
      "partnersSettingsProfile": "Προφίλ",
      "root": "Εφαρμογή",
      "usersPaused": "Η πρόσβασή σας είναι σε παύση"
    }
  }
}
